import React from "react";

const HtmlIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.494"
      height="24.594"
      viewBox="0 0 20.494 24.594"
    >
      <path
        id="db40"
        d="M212.593,163.662a2.218,2.218,0,0,0-1.861-.771H200.049c-1.174,0-1.635.461-1.635,1.635v21.323c0,1.174.461,1.635,1.635,1.635h17.224c1.174,0,1.635-.461,1.635-1.635V171.067a2.218,2.218,0,0,0-.771-1.861Zm4.885,21.957c0,.313-.123.436-.436.436H200.28c-.313,0-.436-.123-.436-.436v-5.29h17.634v5.29Zm-14.5-9.565v-1.89H204v4.919h-1.022v-2.058h-1.688v2.058h-1.028v-4.919h1.028v1.89Zm1.572-.956v-.934h3.483v.934h-1.237v3.985h-1.029V175.1Zm3.9,3.985.29-4.919H210.1l.444,1.642c.141.569.282,1.182.383,1.759h.02c.128-.569.283-1.219.43-1.766l.484-1.635H213.2l.249,4.919h-1l-.067-1.883c-.02-.591-.04-1.306-.04-2.021h-.021c-.141.628-.329,1.328-.5,1.9L211.263,179h-.8l-.484-1.9c-.148-.577-.3-1.277-.41-1.919h-.013c-.027.664-.047,1.423-.081,2.036l-.08,1.869Zm8.618-.934v.934h-2.83v-4.919h1.028v3.985Zm.414-5.232H199.844v-8.159c0-.313.123-.436.436-.436h10.888c.156,0,.218.062.218.218v4.239c0,1.174.461,1.635,1.635,1.635h4.239c.157,0,.218.062.218.218Z"
        transform="translate(-198.414 -162.891)"
        fill={fill ? fill : "#707070"}
      />
    </svg>
  );
};

export default HtmlIcon;
